export default "__VITE_ASSET__DBxMOWxq__"